import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export function MaskedLines({ lines, className = '', delay = 0, stagger = 0.12 }) {
  return (
    <div className={className}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            data-testid={i === 0 ? 'hero-masked-line' : undefined}
            className="block will-change-transform"
            initial={{ y: '115%' }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = '', amount = 0.15 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Rule({ delay = 0, className = '' }) {
  return (
    <motion.div
      className={`h-px bg-ink/25 origin-left ${className}`}
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 1.2, delay, ease: EASE }}
    />
  );
}

const AR = {
  std: 'aspect-[4/3]',
  tall: 'aspect-[3/4]',
  wide: 'aspect-[16/9]',
  band: 'aspect-[21/9]',
  portrait: 'aspect-[2/3]',
  landscape: 'aspect-[15/11]',
};

const SPAN = {
  1: 'md:col-span-1',
  2: 'md:col-span-2',
  3: 'md:col-span-3',
  4: 'md:col-span-4',
  6: 'md:col-span-6',
};

import { useLang } from '../i18n';

export function GalleryRow({ row }) {
  const { t } = useLang();
  const center = row.length === 1 && row[0].c === 3;
  return (
    <div className="grid grid-cols-6 gap-4 md:gap-6">
      {row.map((im, i) => (
        <FadeUp
          key={im.s}
          delay={i * 0.08}
          className={`col-span-6 ${center ? '' : SPAN[im.c]}`}
        >
          <figure className={`group ${center ? 'mx-auto w-full md:w-1/2' : ''}`}>
            <div className={`overflow-hidden bg-paper ${AR[im.ar]}`}>
              <img
                src={`/work/${im.s}.jpg`}
                alt=""
                loading="lazy"
                data-testid={`gallery-image-${im.s}`}
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]"
              />
            </div>
            {im.caption && (
              <figcaption className="mt-2 text-[10px] uppercase tracking-[0.2em] text-ink/60">
                {t(im.caption)}
              </figcaption>
            )}
          </figure>
        </FadeUp>
      ))}
    </div>
  );
}


